import { Injectable } from '@angular/core';

import { GetProductsResponse, ProductItem } from '@app-model/response';

@Injectable({
  providedIn: 'root',
})
export class SortingService {
  static sortStrings<T>(arrayToSort: T[]): T[] {
    arrayToSort.sort(function (a, b) {
      const nameA = a['name'].toLowerCase();
      const nameB = b['name'].toLowerCase();

      if (nameA < nameB) {
        // sort string ascending
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0; // default return value (no sorting)
    });

    return arrayToSort;
  }

  static sortGridArray(product: ProductItem[], ASC: boolean, sortBy: string): ProductItem[] {
    product.sort((a, b) => {
      let nameA: string | number;
      let nameB: string | number;

      switch (sortBy) {
        case 'product': {
          nameA = a.productDescription.enUsProductDescription.toLowerCase();
          nameB = b.productDescription.enUsProductDescription.toLowerCase();
          break;
        }
        case 'plan': {
          nameA = a.planName.enUsPlanName.toLowerCase();
          nameB = b.planName.enUsPlanName.toLowerCase();
          break;
        }
        case 'term': {
          nameA = +a.maxTerm;
          nameB = +b.maxTerm;
          break;
        }
        case 'cost': {
          nameA = +a.customerCost;
          nameB = +b.customerCost;
          break;
        }
      }

      if (nameA < nameB) {
        // sort string ascending
        return ASC ? -1 : 1;
      }
      if (nameA > nameB) {
        return ASC ? 1 : -1;
      }

      return 0; // default return value (no sorting)
    });

    return product;
  }

  static sortProductResponse(response: GetProductsResponse): GetProductsResponse {
    response.availableOptions.products.productItem = response.availableOptions.products.productItem.sort((a, b) => {
      if (a.productCategory === 'PPM' || a.productCategory === 'LWT') {
        return a.planName.enUsPlanName.localeCompare(b.planName.enUsPlanName, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      }
    });

    return response;
  }
}
